module.exports = __webpack_public_path__ + "static/media/icon_quanly_phongban.86ccb649.svg";